import React, { useEffect, useState } from 'react'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  LinearProgress
} from '@material-ui/core'

const expectedPermissions = [
  { app: 'zicsa', menu: 'purchase_orders' },
  { app: 'zicsa', menu: 'invoices' },
  { app: 'zicsa', menu: 'status_invoices' },
  { app: 'zicsa', menu: 'invoices_journal' },
  { app: 'admin', menu: 'staff' }
]

const appLabel = (app) => {
  if (app === 'zicsa') {
    return 'Zicsa'
  }

  if (app === 'admin') {
    return 'Administracion'
  }

  return app
}

const menuLabel = (menu) => {
  if (menu === 'staff') {
    return 'Usuarios'
  }

  if (menu === 'purchase_orders') {
    return 'Ordenes de compra'
  }

  if (menu === 'invoices') {
    return 'Notas de ingreso'
  }

  if (menu === 'status_invoices') {
    return 'Estado facturas'
  }

  if (menu === 'invoices_journal') {
    return 'Registro pre-facturas'
  }
  
  return menu
}

const permissionKey = (permission) => `${permission.app}-${permission.menu}`

const PermissionRow = ({ record, isAdmin }) => {
  return (
    <TableRow>
      <TableCell align="left">
        {appLabel(record.app)}
      </TableCell>
      <TableCell align="left">
        {menuLabel(record.menu)}
      </TableCell>
      <TableCell align="left">
        {
          record.read || isAdmin
            ? 'SI'
            : 'NO'
        }
      </TableCell>
      <TableCell align="left">
        {
          record.write || isAdmin
            ? 'SI'
            : 'NO'
        }
      </TableCell>
    </TableRow>
  )
}

export default ({ data, loaded, basePath, isAdmin = false }) => {
  const [permissions, setPermissions] = useState({})

  useEffect(() => {
    if (data) {
      const items = Object.values(data)
        .reduce((accu, permission) => {
          accu[permissionKey(permission)] = permission
          return accu
        }, {})

      setPermissions(items)
    }
  }, [data])

  if ((loaded && data) === false) {
    return <LinearProgress />
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell align="left">
            Aplicacion
          </TableCell>
          <TableCell align="left">
            Menu
          </TableCell>
          <TableCell align="left">
            Lectura
          </TableCell>
          <TableCell align="left">
            Escritura
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {
          expectedPermissions.map((expectedPermission) => {
            const record = permissions[permissionKey(expectedPermission)] || {
              ...expectedPermission,
              read: false,
              write: false
            }

            return (
              <PermissionRow
                key={permissionKey(expectedPermission)}
                isAdmin={isAdmin}
                record={record}
              />
            )
          })
        }
      </TableBody>
    </Table>
  )
}